// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"49499eb0","213":"c79836de","453":"73a353d6","667":"92a5e3d2","806":"5b9581e0"}[chunkId] + ".chunk.js";
};